import { createAccessControl } from "better-auth/plugins/access";

export const ac = createAccessControl({
    user: ["create", "list", "set-role", "ban", "impersonate", "delete", "set-password", "get", "update"],
    session: ["list", "revoke", "delete"],
});

export const roles = {
    admin: ac.newRole(ac.statements),
    user: ac.newRole({
        user: ["create"],
    }),
    service: ac.newRole({
        user: [],
    }),
};

export const orgAC = createAccessControl({
    organization: ["update", "delete"],
    member: ["create", "update", "delete", "list"],
    manager: ["create"] as const,
    invitation: ["create", "cancel"],
    team: ["create", "update", "delete"],
    ac: ["create", "read", "update", "delete"],
    acknowledgements: ["all"],
});

export const orgRoles = {
    admin: orgAC.newRole(orgAC.statements),
    manager: orgAC.newRole({
        organization: ["update"],
        member: ["create", "update", "delete", "list"],
        team: ["create", "update", "delete"],
    }),
    member: orgAC.newRole({
        organization: [],
        member: ["list"],
    }),
};

export type Statements = {
    -readonly [K in keyof typeof ac.statements]?: (typeof ac.statements)[K][number][];
};

export type Role = keyof typeof roles;

export type OrgStatements = {
    -readonly [K in keyof typeof orgAC.statements]?: (typeof orgAC.statements)[K][number][];
};

export type OrgRole = keyof typeof orgRoles;
